<script setup lang="ts">
import type { RadioProps } from '~/types/input';

const {
    showLabel = true,
    validationType = 'none',
    successMessage = '',
    infoMessage = '',
    errorMessage = '',
    warningMessage = '',
    required = false,
    showOptionalLabel = true,
    options = [],
} = defineProps<RadioProps>();

const validationMessage = computed(() => {
    return {
        error: errorMessage,
        success: successMessage ?? '',
        warning: warningMessage ?? '',
        info: infoMessage ?? '',
        none: '',
    };
});

const model = defineModel({ type: String });
</script>

<template>
    <div class="flex flex-col flex-wrap gap-2 md:flex-row">
        <header v-if="showLabel" class="flex justify-between font-semibold">
            {{ label }}
            <span v-if="!required && showOptionalLabel" class="font-normal">{{
                $t('form.optional')
            }}</span>
        </header>
        <div class="relative flex w-full flex-col gap-2 md:flex-row">
            <template v-for="option in options" :key="option.id">
                <div>
                    <input
                        :id="option.id"
                        v-model="model"
                        :required="required"
                        type="radio"
                        :value="option.value"
                        :name="name" />
                    <label :for="option.id">{{ option.label }}</label>
                </div>
            </template>
        </div>
        <HelperText
            v-if="validationType !== 'none' && validationType !== undefined"
            class="mt-2"
            :icon="validationType"
            :variant="validationType"
            :text="validationMessage[validationType]" />
    </div>
</template>

<style lang="css" scoped>
@reference "~/assets/css/main.css";

input[type='radio'] {
    @apply h-0 w-0 appearance-none;
}

input[type='radio'] + label {
    @apply btn-secondary-a;
}

input[type='radio']:checked + label {
    @apply btn-primary-a;
}
</style>
